import { SET_LOT_DETAILS, CLEAR_LOT, SET_TOTAL_STEPS } from "../actions/lot";
import { MAX_ALLOWED_PICKUP_DAY } from "../../config";

const INITIAL_STATE = {
  year: "",
  color: "",
  make: "",
  model: "",
  referenceNumber: "",
  uuid: "",
  yardPhoneNumber: "",
  totalSteps: 4,
  maxAllowedPickupDays: MAX_ALLOWED_PICKUP_DAY,
  holidays:[],
  logo: null,
  isSellerLogoOn: false
};

export const lotReducer = (lot = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LOT_DETAILS:
      return { ...lot, ...action.payload };
    case CLEAR_LOT:
      return INITIAL_STATE;

    case SET_TOTAL_STEPS:
      return { ...lot, totalSteps: action.payload };

    default:
      return lot;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/lot.js